import { render } from "./sick.vue?vue&type=template&id=747402e3"
import script from "./sick.vue?vue&type=script&lang=js"
export * from "./sick.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__